import React from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';

import apiPath from 'apiPath';
import stickyError from 'components/stickyError';

import { formItemLayout, tailFormItemLayout } from './formItemLayout.js';

class SetPassword extends React.Component {
	state = { redirectToLogin: false }
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.form.validateFields((error, values) => {
			if (error) {
				console.error(error);
				return stickyError('Invalid input');
			} else {
				const data = Object.assign(
					{newPassword: values.password1},
					this.props.match.params
				);
				axios.post(apiPath+'/auth/setPassword', data, {withCredentials: true})
					.then(result => {
						notification.open({
							message: 'Your password has been set',
							description: 'Please log in with your new password'
						});
						this.setState({ redirectToLogin: true });
					}).catch(error => stickyError('An error occurred'));
			}
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		if (this.state.redirectToLogin) return <Redirect to="/" />;
		return(
			<div>
				<legend>Choose a new password</legend>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item label="New Password" {...formItemLayout}>
						{getFieldDecorator('password1', {
							rules: [
								{required: true, message: 'Password is required'},
								{min: 8, message: 'Password must be at least 8 characters long'}
							],
							validateTrigger: ['onBlur']
						})(
							<Input type="password" />
						)}
					</Form.Item>
					<Form.Item label="Confirm Password" {...formItemLayout}>
						{getFieldDecorator('password2', {
							rules: [
								{required: true, message: 'Password (repeat) is required'},
								{validator: (rule, value, callback) => {
									const matching = value && value === this.props.form.getFieldValue('password1');
									if (matching) return callback();
									else return callback("Passwords don't match");
								}}
							],
							validateTrigger: ['onBlur']
						})(
							<Input type="password" />
						)}
					</Form.Item>
					<Form.Item {...tailFormItemLayout}>
						<Button type="primary" htmlType="submit">
							Set Password
						</Button>
					</Form.Item>
				</Form>
			</div>
		);
	}
}

export default Form.create()(SetPassword);



// WEBPACK FOOTER //
// ./src/containers/Login/SetPassword.jsx